import PropTypes from 'prop-types';

const displayName = 'TermsOfService';
const propTypes = {};
const defaultProps = {};

export default { displayName, propTypes, defaultProps };
